const GET_USER_LIST ='getUserList'
const GET_ROLE_LIST ='getRoleList'
const GET_DEVICE_LIST='getDeviceList'
const GET_PROJECT_LIST='getProjectList'

export default {
  GET_USER_LIST,
  GET_ROLE_LIST,
  GET_DEVICE_LIST,
  GET_PROJECT_LIST
}



// WEBPACK FOOTER //
// ./src/store/modules/authority/mutations-types.js